import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Alert from "@material-ui/lab/Alert";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Chip from "@material-ui/core/Chip";
import Scrollbar from "react-scrollbars-custom";
import DeviceGroupsService from "../../services/DeviceGroupsService";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(0.5),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  root: (props) => ({
    flexGrow: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "31.2ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    "& .MuiAlert-root": {
      width: "100%",
      "& > * + *": {
        marginTop: theme.spacing(1),
      },
    },
  }),
  small: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "29ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
  },
  paper: {
    textAlign: "center",
  },
  item: {
    height: "350px",
    alignItems: "center",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

function DepartmentForm() {
  const classes = useStyles();

  const [loc] = React.useState(
    JSON.parse(localStorage.getItem("loc")).id || ""
  );

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setDeviceGroup({ ...deviceGroup, [name]: value });
  };

  const [deviceGroupMessage, setDeviceGroupMessage] = useState("");
  const initialDeviceGroupState = {
    id: null,
    name: "",
  };

  const [deviceGroup, setDeviceGroup] = useState(initialDeviceGroupState);
  const [submitted, setSubmitted] = useState(false);

  const saveDepartment = () => {
    var data = {
      name: deviceGroup.name,
    };

    DeviceGroupsService.create(data)
      .then((response) => {
        setDeviceGroup({
          id: response.data.id,
          name: response.data.name,
        });
        setSubmitted(true);
        setDeviceGroupMessage(
          <Alert severity="success">Успешно добавихте групата!</Alert>
        );
        setTimeout(() => {
          setDeviceGroupMessage(false);
        }, 5000);
        retrieveDeviceGroups();
        console.log(response.data);
      })
      .catch((e) => {
        setSubmitted(true);
        setDeviceGroupMessage(
          <Alert severity="success">Възникна грешка. Опитайте отново!</Alert>
        );
        setTimeout(() => {
          setDeviceGroupMessage(false);
        }, 5000);
        console.log(e);
      });
  };

  const newDepartment = () => {
    setDeviceGroup(initialDeviceGroupState);
    setSubmitted(false);
  };

  const [deviceGroups, setDeviceGroups] = useState([]);

  useEffect(() => {
    retrieveDeviceGroups();
  }, []);

  const retrieveDeviceGroups = () => {
    DeviceGroupsService.getAllAdmin()
      .then((response) => {
        setDeviceGroups(response.data);
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleDelete = (id) => {
    DeviceGroupsService.remove(id)
      .then((response) => {
        setDeviceGroupMessage(
          <Alert severity="success">Успешно премахнахте отдела!</Alert>
        );
        console.log(response.data);
        retrieveDeviceGroups();
        // retrieveDeletedDeviceGroups();
        setTimeout(() => {
          setDeviceGroupMessage();
        }, 5000);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <Card className={classes.item}>
      <AppBar position="static" elevation={0} color="primary">
        <Toolbar className="px-8">
          <Typography
            variant="subtitle1"
            color="inherit"
            className="flex-1 px-12"
          >
            Добави Група
          </Typography>
        </Toolbar>
      </AppBar>
      {deviceGroupMessage}
      <CardContent>
        <Scrollbar id="RSC-Example" style={{ width: "100%", height: "55vh" }}>
          <div className="edit-form">
            <form className={classes.small}>
              <TextField
                required
                id="outlined-required name"
                label="Име на група"
                variant="outlined"
                name="name"
                value={deviceGroup.name}
                onChange={handleInputChange}
                size="small"
              />
              <Button
                onClick={saveDepartment}
                variant="contained"
                color="primary"
              >
                Добави
              </Button>
            </form>
          </div>
          <div className={classes.chips}>
            {deviceGroups.map((deviceGroup) => (
              <Chip
                id={deviceGroup.id}
                onDelete={() => handleDelete(deviceGroup.id)}
                label={deviceGroup.name + " - " + deviceGroup.id}
              />
            ))}
          </div>
        </Scrollbar>
      </CardContent>
    </Card>
  );
}

export default DepartmentForm;
